import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=7242066b&"
import script from "./_name.vue?vue&type=script&lang=js&"
export * from "./_name.vue?vue&type=script&lang=js&"
import style0 from "./_name.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbItem: require('/app/components/breadcrumb/BreadcrumbItem.vue').default,Breadcrumb: require('/app/components/breadcrumb/Breadcrumb.vue').default,ListHeaderTitle: require('/app/components/list/ListHeaderTitle.vue').default,Pagination: require('/app/components/pagination/Pagination.vue').default,ListNews: require('/app/components/list/ListNews.vue').default})
